import React, { useEffect, useState } from 'react';
import { Container, Card, Button, Alert, Row, Col } from 'react-bootstrap';
import { auth } from '../services/firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';

function Dashboard() {
  const navigate = useNavigate();
  const [isSuperUser, setIsSuperUser] = useState(false);

  useEffect(() => {
    const checkSuperUser = async () => {
      if (auth.currentUser?.email) {
        const superUsersRef = collection(db, 'super_users');
        const q = query(superUsersRef, where('email', '==', auth.currentUser.email));
        const querySnapshot = await getDocs(q);
        setIsSuperUser(!querySnapshot.empty);
      }
    };

    checkSuperUser();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  if (!auth.currentUser) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">
          Please log in to view your dashboard.
        </Alert>
      </Container>
    );
  }

  return (
    <div className="container mt-5" style={{ maxWidth: '800px', background: '#f0f0f0' }}>
      <Card className="shadow-sm mt-4">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start mb-2">
            
            <div>
              <h2 className="mb-1">My Account</h2>
              <p className="text-muted mb-0">
                <i className="bi bi-envelope me-2"></i>
                {auth.currentUser.email}
              </p>
            </div>
            <Button 
              variant="outline-danger" 
              onClick={handleLogout}
              className="ms-3"
            >
              <i className="bi bi-box-arrow-right me-2"></i>
              Logout
            </Button>
          </div>

          <hr className="my-4" />

          <h5 className="mb-3">Quick Links</h5>
          <div className="d-grid gap-2">
            <Button 
              variant="outline-primary" 
              onClick={() => navigate('/members')}
              className="text-start"
            >
              <i className="bi bi-people me-2"></i>
              View Members
            </Button>
            <Button 
              variant="outline-primary" 
              onClick={() => navigate('/itinerary')}
              className="text-start"
            >
              <i className="bi bi-calendar-event me-2"></i>
              View Itinerary
            </Button>
            {isSuperUser && (
              <Button 
                variant="outline-primary" 
                onClick={() => navigate('/login-ledger')}
                className="text-start"
              >
                <i className="bi bi-journal-text me-2"></i>
                View Login Ledger
              </Button>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Dashboard; 